export const AxisTickPlacement = {
  ON: 'on',
  BETWEEN: 'between',
  OUTSIDE: 'outside',
  INSIDE: 'inside',
};
